export default function initA11yMenu() {
    const wrapper = document.querySelector('.c-a11y');
    const trigger = document.querySelector('.c-a11y__trigger');
    const menu = document.querySelector('.c-a11y__menu');
    const html = document.documentElement;
    const body = document.body;

    if (!wrapper || !trigger || !menu) return;

    let currentZoom = parseFloat(localStorage.getItem('pdr_a11y_zoom')) || 1;
    const isHighContrast = localStorage.getItem('pdr_a11y_contrast') === 'true';

    const applyZoom = () => {
        html.style.fontSize = `${currentZoom * 62.5}%`;
    };

    const applyContrast = () => {
        if (isHighContrast) {
            body.classList.add('is-high-contrast');
        } else {
            body.classList.remove('is-high-contrast');
        }
    };

    applyZoom();
    applyContrast();

    trigger.addEventListener('click', () => {
        const isActive = menu.classList.contains('is-active');

        if (isActive) {
            menu.classList.remove('is-active');
            menu.setAttribute('aria-hidden', 'true');
            trigger.setAttribute('aria-expanded', 'false');
        } else {
            menu.classList.add('is-active');
            menu.setAttribute('aria-hidden', 'false');
            trigger.setAttribute('aria-expanded', 'true');
        }
    });

    document.addEventListener('click', (event) => {
        if (!wrapper.contains(event.target) && menu.classList.contains('is-active')) {
            menu.classList.remove('is-active');
            menu.setAttribute('aria-hidden', 'true');
            trigger.setAttribute('aria-expanded', 'false');
        }
    });

    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && menu.classList.contains('is-active')) {
            menu.classList.remove('is-active');
            menu.setAttribute('aria-hidden', 'true');
            trigger.setAttribute('aria-expanded', 'false');
            trigger.focus();
        }
    });

    const actionButtons = document.querySelectorAll('[data-a11y-action]');

    actionButtons.forEach(btn => {
        btn.addEventListener('click', (e) => {
            const action = e.currentTarget.getAttribute('data-a11y-action');

            if (action === 'zoom-in') {
                if (currentZoom < 1.2) currentZoom += 0.1;
                localStorage.setItem('pdr_a11y_zoom', currentZoom);
                applyZoom();
            }

            if (action === 'zoom-out') {
                if (currentZoom > 0.8) currentZoom -= 0.1;
                localStorage.setItem('pdr_a11y_zoom', currentZoom);
                applyZoom();
            }

            if (action === 'contrast') {
                body.classList.toggle('is-high-contrast');
                const newState = body.classList.contains('is-high-contrast');
                localStorage.setItem('pdr_a11y_contrast', newState);
            }
        });
    });
}